module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// ../~/inline-style-prefixer/static.js
// module id = 1458
// module chunks = 2